<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="代理商ID">
        <el-input
          v-model="formInline.agentid"
          placeholder="请输入代理商ID"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="代理商名">
        <el-input
          v-model="formInline.agentName"
          placeholder="请输入代理商名"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商手机">
        <el-input
          v-model="formInline.agentMobile"
          placeholder="请输入代理商手机"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商联系人">
        <el-input
          v-model="formInline.agentContact"
          placeholder="请输入代理商联系人"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商所在城市">
        <el-select v-model="formInline.agentCity" placeholder="请选择">
          <el-option
            v-for="(item, index) in CITY_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <!-- <el-table-column prop="agentid" label="代理商ID"></el-table-column> -->
      <el-table-column
        prop="agentLoginAccount"
        label="登录名"
      ></el-table-column>
      <el-table-column prop="agentName" label="代理商名"></el-table-column>
      <el-table-column prop="agentContact" label="联系人"></el-table-column>
      <el-table-column prop="agentMobile" label="联系手机"></el-table-column>
      <el-table-column prop="agentCity" label="所在城市"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row.agentid)"
            >删除</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>

    <EditDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
      :isCreate="isCreate"
      :editInfo="editInfo"
    />
  </div>
</template>

<script>
import enumObject from "../../plugins/enum";
import EditDialog from "./components/editDialog";
export default {
  components: {
    EditDialog
  },
  data() {
    return {
      formInline: {
        agentid: "",
        agentName: "",
        agentMobile: "",
        agentContact: "",
        agentCity: ""
      },
      CITY_ENUM: enumObject.CITY_ENUM,
      multipleSelection: [],
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isDialogShow: false,
      isCreate: true,
      editInfo: null
    };
  },
  methods: {
    onSubmit() {
      this.queryAgent();
    },
    onAdd() {
      this.editInfo = null;
      this.isCreate = true;
      this.isDialogShow = true;
    },
    queryAgent() {
      let queryModel = {
        ...this.formInline,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询代理商"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.queryAgent();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete(agentid) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let agentIDs = [agentid];
        this.$axios(this.$urlMapping["删除代理商"], {
          data: {
            agentIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.queryAgent();
        });
      });
    },
    onBatchDelete() {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let agentIDs = this.multipleSelection.map(ele => ele.agentid);
        this.$axios(this.$urlMapping["删除代理商"], {
          data: {
            agentIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.queryAgent();
        });
      });
    },
    handleEdit(editInfo) {
      this.editInfo = editInfo;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    closeForm() {
      this.isDialogShow = false;
    }
  },
  mounted() {
    this.queryAgent();
  }
};
</script>

<style lang="less" scoped></style>
